import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import {
  DictionaryAssetDeliveryStatus,
  DictionaryContractType,
} from 'src/app/extensions/constants/dictionaryConstants/dictionaryConstants';
import { AssetDeliveryDelegateModalComponent } from '../../asset-modals/asset-delivery-delegate-modal/asset-delivery-delegate-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AssetInspectionModalComponent } from '../../asset-modals/asset-inspection-modal/asset-inspection-modal.component';

@Component({
  selector: 'asset-card-view',
  templateUrl: './asset-card-view.component.html',
  styleUrls: ['./asset-card-view.component.scss'],
  standalone: false,
})
export class AssetCardViewComponent {
  public constructor(
    private _router: Router,
    private _ngbModal: NgbModal
  ) {}

  @Input() public assets: app.models.AssetListModel[] = [];
  @Input() public orderedAssets: app.models.AssetListModel[] = [];
  @Input() public requestAccessWarnings: string[] = [];
  @Input() public props: app.models.DynamicPropsDictionary;
  @Input() public navigateToDetailHandler: any;
  @Input() public activeContracts: boolean = true;

  ContractType = DictionaryContractType;
  AssetDeliveryStatus = DictionaryAssetDeliveryStatus;

  redirectDocumentRequest(event: Event, contractId: string, assetId: string) {
    event.stopPropagation();
    this._router.navigate(['requests/new', contractId, assetId]);
  }

  openAssetInspectionModal(event: Event) {
    event.stopPropagation();
    this._ngbModal.open(AssetInspectionModalComponent, {
      centered: true,
      scrollable: true,
    });
  }

  openDelegateModal(event: Event, asset: app.models.AssetListModel) {
    event.stopPropagation();
    const modalRef = this._ngbModal.open(AssetDeliveryDelegateModalComponent, {
      scrollable: true,
    });
    modalRef.componentInstance.asset = asset;
  }
}
